// extracted by mini-css-extract-plugin
module.exports = {"container":"_9ogO6luW"};